/*
 * This functionality is used to replace chars which could break JSON structure.
 * Example: rendering custom component as string, while passing props that have
 * any of these sensitive characters (check setTableInsideArticle method for
 * specific example)
 */
const SINGLE_QUOTES_SHORTCODE = '[#singlequotes#]'
const DOUBLE_QUOTES_SHORTCODE = '[#doublequotes]'

const QUOTED_SYMBOLS = ['[', ']', '#']

const SHORTCODE_BY_CHAR = {
  "'": SINGLE_QUOTES_SHORTCODE,
  '"': DOUBLE_QUOTES_SHORTCODE
}

const CHAR_BY_SHORTCODE = Object.fromEntries(
  Object.entries(SHORTCODE_BY_CHAR).map(([ch, sc]) => [sc, ch])
)

function escapeChars(text) {
  return text
    .split('')
    .map(char => (QUOTED_SYMBOLS.includes(char) ? `\\${char}` : char))
    .join('')
}

// Build regexes once
const charAlternation = Object.keys(SHORTCODE_BY_CHAR)
  .map(c => escapeChars(c))
  .join('|')

const shortcodeAlternation = Object.keys(CHAR_BY_SHORTCODE)
  .map(sc => escapeChars(sc))
  .join('|')

const CHAR_REGEX = new RegExp(charAlternation, 'g')
const SHORTCODE_REGEX = new RegExp(shortcodeAlternation, 'g')

export function encodeAttributeQuotes(input = '') {
  if (!input) return ''

  return input.replace(CHAR_REGEX, m => SHORTCODE_BY_CHAR[m])
}

export function decodeAttributeQuotes(input = '') {
  if (!input) return ''

  return input.replace(SHORTCODE_REGEX, m => CHAR_BY_SHORTCODE[m])
}
